"use client";

import { GoogleTagManager, sendGTMEvent } from "@next/third-parties/google";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export function Analytics({ id }: { id: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      sendGTMEvent({
        event: "pageview",
        page: pathname,
      });
    }
  }, [pathname, searchParams]);

  return <GoogleTagManager gtmId={id} />;
}
